import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import printJS from 'print-js';
import moment from 'moment';
import classnames from 'classnames';
import Top from 'Components/top';
import LoadingOverlay from 'Components/loading-overlay';
import loc from 'Components/languages';
import Button from 'Components/button';
import { viewOrder, printOrder } from 'Redux/actions';
import styles from './PageOrderView.less';

class PageOrderView extends PureComponent {
	constructor() {
		super();
		this.state = {
			hideWarehouseName: false,
		};
		this.getId = this.getId.bind(this);
		this.viewOrder = this.viewOrder.bind(this);
		this.isLoading = this.isLoading.bind(this);
		this.onClickPrintHandler = this.onClickPrintHandler.bind(this);
		this.onClickDownloadHandler = this.onClickDownloadHandler.bind(this);
	}

	componentDidMount() {
		this.viewOrder();
	}

	getId(props = null) {
		if (!props) {
			props = this.props;
		}
		return props.match.params.transactionNumber;
	}

	viewOrder() {
		const param = {
			payload: {
				trx_no: this.getId(),
				hide_warehouse_name: this.state.hideWarehouseName,
			},
		};
		this.props.viewOrder(param);
	}

	isLoading() {
		const { viewOrderInfo } = this.props;
		return viewOrderInfo.isFetching;
	}

	onClickPrintHandler() {
		const { viewOrderInfo } = this.props;
		printJS({
			printable: viewOrderInfo.data.pdf,
			type: 'pdf',
			base64: true
		});

		const param = {
			payload: {
				trx_no: this.getId(),
				hide_warehouse_name: this.state.hideWarehouseName,
			},
		};
		this.props.printOrder(param);
	}

	onClickDownloadHandler() {
		const { viewOrderInfo } = this.props;
		if (viewOrderInfo && viewOrderInfo.data && viewOrderInfo.data.pdf) {
			const linkSource = `data:application/pdf;base64,${viewOrderInfo.data.pdf}`;
			const downloadLink = document.createElement('a');
			const fileName = `${this.getId()}.pdf`;

			downloadLink.href = linkSource;
			downloadLink.download = fileName;
			downloadLink.click();
		}
	}

	render() {
		const { viewOrderInfo } = this.props;
		const isLoading = this.isLoading();
		const transactionNumber = this.getId();
		const transactionDate = (viewOrderInfo && viewOrderInfo.data && viewOrderInfo.data.transaction_date) ? moment(viewOrderInfo.data.transaction_date) : null;
		const viewOrderInfoMember = (viewOrderInfo?.data?.member?.member_code) ? viewOrderInfo.data.member : null;

		return (
			<LoadingOverlay active={ isLoading }>
				<div className="uk-flex uk-flex-column">
					<Top name="orderSearch" />
					<div>
						<div
							className="stepContainer uk-height-large uk-position-relative"
							data-uk-height-viewport="offset-top: true; offset-bottom: 64px"
						>
							<div className="uk-width-1-1 uk-height-1-1">
								<div className="uk-width-1-1 uk-flex uk-flex-top uk-flex-wrap uk-padding-small uk-padding-remove-horizontal uk-padding-remove-top">
									<h3 className={ classnames('uk-text-primary', 'uk-text-bold', 'uk-text-uppercase', 'uk-flex-none', styles.title) }>
										{ loc.print }
									</h3>

									<div className="uk-flex uk-flex-column uk-flex-top uk-flex-auto uk-margin-small-left">
										<h3 className="uk-text-primary uk-text-bold uk-text-uppercase uk-margin-remove uk-padding-remove">
											<small>
												{
													transactionDate && (
														`Ordered on ${transactionDate.format('YYYY-MM-DD HH:mm:ss')} / `
													)
												}
												Order# { transactionNumber }
											</small>
										</h3>

										{viewOrderInfoMember && (
											<h5 className="uk-text-primary uk-text-bold uk-margin-small-left uk-margin-remove uk-padding-remove">
												{viewOrderInfoMember.member_code} / {viewOrderInfoMember.member_name} / {viewOrderInfoMember.phone}
											</h5>
										)}
									</div>
									{
										viewOrderInfo && viewOrderInfo.data && (
											<div className="uk-flex uk-flex-none uk-flex-middle uk-padding-small">
												{
													viewOrderInfo.data && viewOrderInfo.data.show_checkbox_hide_warehouse_name && (
														<label className="uk-flex uk-flex-middle uk-flex-none uk-text-medium uk-text-bold uk-text-danger uk-margin-small-right">
															<input
																type="checkbox"
																className="uk-checkbox uk-margin-small-right"
																checked={ this.state.hideWarehouseName }
																onChange={ (e) => this.setState({ hideWarehouseName: e.target.checked }, this.viewOrder) }
															/>
															Hide Shop Name on Invoice
														</label>
													)
												}
												{
													viewOrderInfo.data.pdf && (
														<Button
															text={ loc.download }
															theme="primary"
															disabled={ isLoading }
															padding="small"
															className="uk-margin-small-left"
															onClick={ this.onClickDownloadHandler }
														/>
													)
												}
												{
													viewOrderInfo.data.allow_printing && (
														<Button
															text={ loc.printInvoice }
															theme="primary"
															disabled={ isLoading }
															padding="small"
															className="uk-margin-small-left"
															onClick={ this.onClickPrintHandler }
														/>
													)
												}
											</div>
										)
									}
								</div>
								{
									viewOrderInfo && viewOrderInfo.data && viewOrderInfo.data.pdf ? (
										<iframe
											src={ `data:application/pdf;base64,${viewOrderInfo.data.pdf}${viewOrderInfo.data.orientation === 'landscape' ? '#zoom=200' : ''}` }
											className={ styles.pdf }
										/>
									) : (
										<div />
									)
								}
							</div>
						</div>
					</div>
				</div>
			</LoadingOverlay>
		);
	}
}

export default connect(
	(state) => ({
		viewOrderInfo: state.viewOrderInfo,
	}),
	(dispatch) => ({
		viewOrder: para => dispatch(viewOrder(para)),
		printOrder: para => dispatch(printOrder(para)),
	})
)(PageOrderView);
